/// <reference path="../../TypeLite.Net4.d.ts" />

import moment from "moment";

export interface ISelectableItem {
	title: string;
	description?: string;
	code?: string;
	imageUrl?: string;
	selected: boolean;
	data: any; //original data item 
	imageClassName?: string;
}

export class SelectableItemConverter {
	static convertModels(models: SkodaAuto.Marvin.ServiceAvailability.Web.App.Models.Data.ModelFamilyModel[]): ISelectableItem[] {
		const ret: ISelectableItem[] = [];
		for (let i = 0; i < models.length; i++) {
			const model: ISelectableItem = {
				title: models[i].Title,
				code: models[i].Code,
				imageUrl: models[i].SideImageUrl,
				selected: false,
				data: models[i],
				imageClassName: 'new-render'
			};

			ret.push(model);
		}

		return ret;
	}

	static convertInfotainments(infotainments: SkodaAuto.Marvin.ServiceAvailability.Web.App.Models.Data.InfotaimentModel[]): ISelectableItem[] {
		const ret: ISelectableItem[] = [];
		for (let i = 0; i < infotainments.length; i++) {
			const infotainment: ISelectableItem = {
				title: infotainments[i].Title,
				code: infotainments[i].Code,
				imageUrl: infotainments[i].Image,
				selected: false,
				data: infotainments[i]
			};

			ret.push(infotainment);
		}

		return ret;
	}

	static convertPeriods(periods: SkodaAuto.Marvin.ServiceAvailability.Web.App.Models.Data.ProductionIntervalModel[], dateFormat: string = "DD.MM.YYYY"): ISelectableItem[] {
		const ret: ISelectableItem[] = [];
		for (let i = 0; i < periods.length; i++) {
			const p = periods[i];
			const period: ISelectableItem = {
				title: this.formatPeriodText(p.From ? new Date(p.From.ProductionDate).getFullYear() : null, p.To ? new Date(p.To.ProductionDate).getFullYear() : null),
				code: p.From.Code,
				description: this.formatPeriodText(p.From ? p.From.Title : null, p.To ? p.To.Title : null),
				selected: false,
				data: periods[i]
			};

			ret.push(period);
		}

		return ret;
	}

	private static formatDateInterval(dateFrom: Date, dateTo: Date, dateFormat: string): string {
		return this.formatPeriodText(dateFrom ? moment(dateFrom).format(dateFormat) : null, dateTo ? moment(dateTo).format(dateFormat) : null);
	}

	private static formatPeriodText(from: any, to: any): string {
		if (!from || !to || from === to) {
			return from ? from : to;
		}

		return from + " - " + to;
	}

	static convertCountries(countries: SkodaAuto.Marvin.ServiceAvailability.Web.App.Models.Data.CodeListItemModel[]): ISelectableItem[] {
		const ret: ISelectableItem[] = [];
		for (let i = 0; i < countries.length; i++) {
			const country: ISelectableItem = {
				title: countries[i].Value,
				code: countries[i].Code,
				imageUrl: countries[i].ImageUrl,
				selected: false,
				data: countries[i]
			};

			ret.push(country);
		}

		return ret;
	}
}